import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="schema-field-edit-drawer" on the section wrapping the
// schema attributes table + the edit drawer. Opens the drawer and lazy-loads the field's
// edit form into its content frame.
//
// Per-row Edit links carry the URL via data-schema-field-edit-drawer-url-param.
export default class extends Controller {
  static targets = ["frame"]
  static values = { identifier: { type: String, default: "schema-field-edit" } }

  open(event) {
    event.preventDefault()
    const url = event.params.url
    if (url && this.hasFrameTarget) {
      if (this.frameTarget.getAttribute("src") === url) {
        this.frameTarget.reload()
      } else {
        this.frameTarget.setAttribute("src", url)
      }
    }
    // drawer-instance listens for drawer:open@window and matches by element id.
    window.dispatchEvent(new CustomEvent("drawer:open", { detail: { instance: this.identifierValue } }))
  }
}
